import { parseWorkflowId } from './parseWorkflowId';

/** What the `/view/:contentId` route should open, decoded from its query string. */
export type ViewTarget =
  | { readonly kind: 'read-draft' }
  | { readonly kind: 'read-publication'; readonly workflowId?: number }
  | { readonly kind: 'unsupported' };

/**
 * Decode a `/view` query string into a {@link ViewTarget}. `mode=publication`
 * opens a published version — optionally pinned to a specific `workflowId`.
 * No `mode` and no `workflowId` means the live draft. A `workflowId` without
 * `mode=publication` is `unsupported` — a workflow of a kind `/view` can't
 * render (e.g. finalizing).
 *
 * @throws when `workflowId` is present but not a number.
 */
export function parseViewTarget(search: string): ViewTarget {
  const params = new URLSearchParams(search);
  const workflowId = parseWorkflowId(params.get('workflowId'));

  // mode=publication opens a published version, with or without a pinned workflowId.
  if (params.get('mode') === 'publication') return { kind: 'read-publication', workflowId };

  // A workflowId without mode=publication is unsupported — we can't infer the kind.
  if (workflowId !== undefined) return { kind: 'unsupported' };

  return { kind: 'read-draft' };
}
